module.exports = "<footer>\n    <div class=\"container-fluid\">\n        <p class=\"copyright pull-left\">\n            Mo with ❤ &copy; {{test | date: 'yyyy'}}\n        </p>\n        <p class=\"copyright pull-right\">\n            v{{env.version}}\n        </p>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main